/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TranslateWarningDTO { 
    json_pointer?: string;
    sorgente?: string;
    params?: any | null;
    message_key?: string;
    message?: string;
}

